<template>
  <MiniProduct />
  <AddToBag />
  <DataCollection v-if="showDataCollection" />
  <CookieMessage v-if="!isPlaywright" />
  <WishlistLogin />
  <StockNotification />
</template>

<script>
import MiniProduct from "@/components/MiniProduct.vue";
import AddToBag from "@/components/add-to-bag/AddToBag.vue";
import DataCollection from "@/components/DataCollection.vue";
import CookieMessage from "@/components/CookieMessage.vue";
import WishlistLogin from "@/components/WishlistLogin.vue";
import StockNotification from "@/components/StockNotificationV2.vue";
import { getParams } from "@/helpers/url.js";
import { regionFeatureToggles } from "@/config.js";
import { mapGetters } from "vuex";

export default {
  name: "GlobalComponent",
  components: {
    AddToBag,
    DataCollection,
    CookieMessage,
    WishlistLogin,
    MiniProduct,
    StockNotification,
  },
  inject: ["isPlaywright"],
  computed: {
    ...mapGetters("app", ["currencyCode"]),
    isUtmSource() {
      const params = getParams();
      const utmSource = params.utm_source;
      if (utmSource === "Klaviyo") {
        return true;
      }
      return false;
    },
    dataCollectionEnabled() {
      return regionFeatureToggles[this.currencyCode]?.dataCollectionEnabled;
    },
    showDataCollection() {
      if (!this.dataCollectionEnabled) {
        return false;
      }
      if (this.isPlaywright) {
        return false;
      }
      if (this.isUtmSource) {
        return false;
      }
      if (window.location.pathname === "/pages/flash-sale-signup") {
        return false;
      }
      return true;
    },
  },
};
</script>
